import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/auth";
import TablaProveedores from "./tablaProveedores";
import TablaUnidadesMedidas from "./tablaUnidadesMedidas";
import TablaTipopro from "./tablaTipopro";
import TablaRequisicion from "./tablaRequisicion";
// import TablaSolicitudCom from './tablaSolicitudCompra';
import TablaOrdenCompra from "./tablaOrdenCompra";
import TablaAprobadasSolicitudesCompra from "./tablaAprobadasSolicitudsCompras";
import ImpCompraAlmacen from "./impComprasAlmacen";
import TablaUsuarioCompra from "./tablaUsuarioCompra";

import { Toasts } from "../toasts";
import TablaAlmacen from "./almacen/registroAlmacen";
import { GestionarUbicaciones } from "./almacen/modalUbicacionesAlmacen";
import { GestionarMarca } from "./almacen/modalMarca";
import { GestionarModelo } from "./almacen/modalModelo";
import { GestionarFabricantes } from "./almacen/modalFabricante";
import TablaProdTerminadoe from "./almacen/tablaProductos";
import TablaOperInventario from "./tablaOperacionesInventario";
import { ImprimirProductos } from "./almacen/impProductoExistencia";
import SeleccionarAlmacen from "./almacen/modalSeleccionarAlmacen";
import Menu from "../comun/Menu/Menu";
import Item from "../comun/Menu/Item";
import imgCompra from "../../imagenes/fd_compras.png";
import Footer from "../Footer";
import ModalImprimirProductoProveedor from "./modalImprimirProductoProveedor";
import PanelAdministraivo from './panelAdministrativo'
function MenuPrincipalCompra() {
  const { user, logout } = useContext(AuthContext);
  const accproveedor =
    JSON.parse(localStorage.getItem("accproveedor")) === null
      ? "0000"
      : JSON.parse(localStorage.getItem("accproveedor")).trim();
  const accsolicompra =
    JSON.parse(localStorage.getItem("accsolicompra")) === null
      ? "0000"
      : JSON.parse(localStorage.getItem("accsolicompra")).trim();
  const accaprosolicompra =
    JSON.parse(localStorage.getItem("accaprosolicompra")) === null
      ? "0"
      : JSON.parse(localStorage.getItem("accaprosolicompra")).trim();
  const accunimedi =
    JSON.parse(localStorage.getItem("accunimedi")) === null
      ? "0000"
      : JSON.parse(localStorage.getItem("accunimedi")).trim();
  const acctipoproducto =
    JSON.parse(localStorage.getItem("acctipoproducto")) === null
      ? "0000"
      : JSON.parse(localStorage.getItem("acctipoproducto")).trim();
  const accproducto =
    JSON.parse(localStorage.getItem("accproducto")) === null
      ? "0000"
      : JSON.parse(localStorage.getItem("accproducto")).trim();

  const efiscalanio = JSON.parse(localStorage.getItem("efiscalanio"));
  const acclisgencompraalmacen = JSON.parse(
    localStorage.getItem("acclisgencompraalmacen"),
  );
  const acclissolicompraalmacen = JSON.parse(
    localStorage.getItem("acclissolicompraalmacen"),
  );
  const afiliado = JSON.parse(localStorage.getItem("riforganizacion"));
  const almacensel = JSON.parse(localStorage.getItem("idalmacen"));

  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));

  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  let op = require("../../../src/modulos/datos");

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };
  const [listadoGeneralPermission, setListadoGeneralPermission] =
    useState(false);
  const [listadoSolicitudesPermission, setListadoSolicitudesPermission] =
    useState(false);

  useEffect(() => {
    setListadoSolicitudesPermission(false);
    setListadoGeneralPermission(false);
    if (acclisgencompraalmacen.toString() === "1")
      setListadoGeneralPermission(true);
    if (acclissolicompraalmacen.toString() === "1")
      setListadoSolicitudesPermission(true);
  }, [acclisgencompraalmacen, acclissolicompraalmacen]);
  const resumenGrafica = {
    title: 'Analisis Grafico',
    icon: 'fa fa-chart-pie me-2',

    drop: [
      {
        title: 'RESUMEN Y ANALISIS GRAFICO',
        icon: 'fas fa-screwdriver me-2',
        itemClickValue: 116
      },

    ]
  }
  const almacenItem = {
    title: "Almacen",
    icon: "fas fa-pen-alt me-2",
    drop: [
      {
        title: "Registro almacen",
        icon: "fas fa-warehouse me-2",
        itemClickValue: 1,
        subDrop: null,
      },
      {
        title: "Seleccionar Almacen",
        icon: "fa fa-calendar me-2",
        itemClickValue: 16,
        subDrop: null,
      },
      {
        title: "Ubicaciones de almacenes",
        icon: "fas fa-map-marker-alt me-2",
        itemClickValue: 2,
        permission: parseInt(almacensel) > 0 ? true : false,
        subDrop: null,
      },
      {
        title: "Marca",
        icon: "fas fa-copyright me-2",
        itemClickValue: 3,
        subDrop: null,
      },
      {
        title: "Modelo",
        icon: "fas fa-list-alt me-2",
        itemClickValue: 4,
        subDrop: null,
      },
      {
        title: "Fabricante",
        icon: "fas fa-industry me-2",
        itemClickValue: 5,
        subDrop: null,
      },
      {
        title: "Unidades de medida",
        icon: "fas fa-tags me-2",
        subDrop: null,
        itemClickValue: 9,
        permission: accunimedi === "0000" ? false : true,
      },
      {
        title: "Tipos de Productos",
        icon: "fas fa-ticket-alt me-2",
        subDrop: null,
        itemClickValue: 10,
        permission: acctipoproducto === "0000" ? false : true,
      },
      {
        title: "Productos/Servicios",
        icon: "fab fa-product-hunt me-2",
        itemClickValue: 6,
        subDrop: null,
        permission: accproducto === "0000" ? false : true,
      },
      {
        title: "Operaciones de inventario",
        icon: "fas fa-truck-loading me-2",
        itemClickValue: 7,
        permission: parseInt(almacensel) > 0 ? true : false,
        subDrop: null,
      },
    ],
  };
  const comprasItem = {
    title: "Compras",
    icon: "fas fa-shopping-cart me-2",
    drop: [
      {
        title: "Registro proveedores",
        icon: "fas fa-user-plus me-2",
        subDrop: null,
        itemClickValue: 8,
        //permission: accproveedor==="0000" ? false : true,
      },

      // {
      //   title: "Requisición",
      //   icon: "fas fa-file-invoice me-2",
      //   subDrop: null,
      //   itemClickValue: 11,
      // },
      {
        title: "Solicitud de Compras/Servicios",
        icon: "fas fa-file-contract me-1",
        subDrop: null,
        itemClickValue: 12,
        permission: accsolicompra === "0000" ? false : true,
      },
      {
        title: "Aprobar Solicitud de Compras",
        icon: "fas fa-check-square me-2",
        itemClickValue: 13,
        permission: accaprosolicompra === "0" ? false : true,
        subDrop: null,
      },
    ],
  };
  const reportesItem = {
    title: "Reportes",
    icon: "fas fa-print me-2",
    drop: [
      {
        title: "Listados Generales »",
        icon: "fas fa-angle-double-right me-2",
        permission: listadoGeneralPermission,
        subDrop: [
          {
            title: "Articulos",
            icon: "far fa-file-pdf me-2",
            itemClickValue: 101,
            subDrop: null,
          },
          {
            title: "Proveedores",
            icon: "far fa-file-pdf me-2",
            itemClickValue: 102,
            subDrop: null,
          },
          {
            title: "Proveedores Activos por Periodos",
            icon: "far fa-file-pdf me-2",
            itemClickValue: 103,
            subDrop: null,
          },
          // {
          //   title: "Productos por Proveedores",
          //   icon: "far fa-file-pdf me-2",
          //   itemClickValue: 104,
          //   subDrop: null,
          // },

          {
            title: "Supervisor »",
            icon: "fas fa-angle-double-right me-2",
            subDrop: [
              {
                title: "Listado General de Ordenes de Compras y Servicios",
                icon: "far fa-file-pdf me-2",
                itemClickValue: 105,
              },
              {
                title: "Ordenes de Compras por Proveedor",
                icon: "far fa-file-pdf me-2",
                itemClickValue: 106,
              },
              /*  {
                                title: 'Disponibilidad Presupuestaria',
                                icon: 'far fa-file-pdf me-2',
                                itemClickValue: 107,
                            } */
            ],
          },
        ],
      },
      {
        title: "Solicitudes »",
        icon: "fas fa-angle-double-right me-2",
        permission: listadoSolicitudesPermission,
        subDrop: [
          {
            title: "Listado Solicitudes de Compras",
            icon: "fas fa-poll-h me-2",
            itemClickValue: 108,
          },
        ],
      },
      {
        title: "Listado de Productos en Existencia",
        icon: "far fa-file-pdf me-2",
        itemClickValue: 14,
      },
      {
        title: "Listado de Productos",
        icon: "far fa-file-pdf me-2",
        itemClickValue: 999,
      },
      {
        title: "Reporte de Productos Proveedor",
        icon: "far fa-file-pdf me-2",
        itemClickValue: 998,
      },
    ],
  };
  const configuracionItem = {
    title: "Configuracion",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Usuarios",
        icon: "fa fa-user me-2",
        itemClickValue: 15,
      },
    ],
  };
  const PorDefecto = () => {
    const azulProfundo = "#003a70";
    const azulVibrante = "#007bff";

    return (
      <section
        className="col-12 m-0 p-0"
        style={{ height: "90dvh", overflow: "hidden" }}
      >
        <style>{`
        @keyframes float {
          0% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
          50% { transform: translateY(-20px) translateX(10px); opacity: 1; }
          100% { transform: translateY(0px) translateX(0px); opacity: 0.6; }
        }
        .tech-dot {
          position: absolute;
          background: white;
          border-radius: 50%;
          animation: float 6s infinite ease-in-out;
        }
      `}</style>

        <div
          className="col-md-12 row mx-auto px-0"
          style={{ minHeight: "100%" }}
        >
          <div
            className="col-md-6 d-flex justify-content-center align-items-center"
            style={{
              position: "relative",
              left: "-50px",
              borderBottomRightRadius: "30%",
              height: "90dvh",
              backgroundColor: azulProfundo,
              overflow: "hidden",
              boxShadow: "10px 0 30px rgba(0,0,0,0.2)",
            }}
          >
            {/* 1. FONDO MESH GRADIENT (Profundidad) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: `
              radial-gradient(circle at 20% 30%, ${azulVibrante} 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, #00d4ff 0%, transparent 50%),
              ${azulProfundo}
            `,
              }}
            />

            {/* 2. REJILLA TECNOLÓGICA (Grid lines) */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), 
                              linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)`,
                backgroundSize: "50px 50px",
              }}
            />

            {/* 3. PUNTOS ANIMADOS (Partículas) */}
            <div
              className="tech-dot"
              style={{
                width: "6px",
                height: "6px",
                top: "20%",
                left: "15%",
                animationDelay: "0s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "4px",
                height: "4px",
                top: "60%",
                left: "25%",
                animationDelay: "1s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "8px",
                height: "8px",
                top: "40%",
                left: "80%",
                animationDelay: "2s",
              }}
            />
            <div
              className="tech-dot"
              style={{
                width: "3px",
                height: "3px",
                top: "80%",
                left: "60%",
                animationDelay: "1.5s",
              }}
            />

            {/* 4. RÁFAGAS DE LUZ DIAGONALES */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 20%, rgba(255,255,255,0.05) 50%, transparent 100%)",
                transform: "skewX(-20deg)",
              }}
            />

            {/* LOGO CON GLOW */}
            <div
              style={{ position: "relative", zIndex: 10, textAlign: "center" }}
            >
              <img
                style={{
                  filter: "drop-shadow(0px 0px 30px rgba(255,255,255,0.3))",
                  maxWidth: "100%",
                  transition: "transform 0.3s ease",
                }}
                className="img-fluid"
                src={imgCompra}
                alt="Logo SIAP"
              />
            </div>
          </div>

          {/* LADO DERECHO (Alcaldía) */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid px-5"
              src={op.imagenes + "/imagen?img=" + op.logohacienda}
              alt="Logo Alcaldía"
              style={{ maxWidth: "85%" }}
            />
          </div>
        </div>
      </section>
    );
  };
  const [show, setShow] = useState(false);
  const [tabla, setTabla] = useState(0);
  useEffect(() => {
    if (tabla === 8) {
      if (accproveedor === "0000") {
        setToast({
          mostrar: true,
          mensaje: "No posee permiso para este modulo.",
          titulo: "Alerta.",
        });
        setTabla(0);
      }
    } else if (tabla === 101) {
      setTabla(0);
      window.open(
        `${op.reportes + "/comprasyalmacen?"}reporte=ListProducto&efiscal=${efiscalanio}`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } else if (tabla === 999) {
      setTabla(0);
      window.open(
        `${op.reportes}/comprasyalmacen?afiliado=${afiliado}&reporte=ListProductoAlmacen`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    }
  }, [tabla]);

  const vista = {
    0: <PorDefecto />,
    116: <PanelAdministraivo />,
    1: <TablaAlmacen cerrar={() => setTabla(0)} />,
    2: (
      <GestionarUbicaciones
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
      />
    ),
    3: (
      <GestionarMarca
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        llamado={1}
      />
    ),
    4: (
      <GestionarModelo
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        llamado={1}
      />
    ),
    5: (
      <GestionarFabricantes
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        llamado={1}
      />
    ),
    6: <TablaProdTerminadoe cerrar={() => setTabla(0)} />,
    7: <TablaOperInventario menu={() => setTabla(0)} />,
    8: <TablaProveedores menu={() => setTabla(0)} />,
    9: (
      <TablaUnidadesMedidas
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        llamado={1}
      />
    ),
    10: (
      <TablaTipopro
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        llamado={1}
      />
    ),
    11: <TablaRequisicion setTabla={setTabla} />,
    12: <TablaOrdenCompra setTabla={setTabla} />,
    13: <TablaAprobadasSolicitudesCompra cerrar={() => setTabla(0)} />,
    14: (
      <ImprimirProductos
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        op={1}
      />
    ),
    15: <TablaUsuarioCompra menu={() => setTabla(0)} />,
    16: (
      <SeleccionarAlmacen
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
      />
    ),

    102: (
      <ImpCompraAlmacen
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        operacion={tabla}
      />
    ),
    // 102: <ImpCompraAlmacen show={show} cerrar={()=>setTabla(0)} setShow={setShow} operacion={tabla}/>,
    103: (
      <ImpCompraAlmacen
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        operacion={tabla}
      />
    ),
    104: (
      <ImpCompraAlmacen
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        operacion={tabla}
      />
    ),
    105: (
      <ImpCompraAlmacen
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        operacion={tabla}
      />
    ),
    106: (
      <ImpCompraAlmacen
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        operacion={tabla}
      />
    ),
    //107: <ImpCompraAlmacen show={show} cerrar={()=>setTabla(0)} setShow={setShow} operacion={tabla} />,
    108: (
      <ImpCompraAlmacen
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        operacion={tabla}
      />
    ),
    109: (
      <ImpCompraAlmacen
        show={show}
        cerrar={() => setTabla(0)}
        setShow={setShow}
        operacion={tabla}
      />
    ),
    998: (
      <ModalImprimirProductoProveedor show={show} setShow={() => setTabla(0)} />
    ),
  };

  return (
    user && (
      <div>
        <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
          <Item item={almacenItem} setTabla={setTabla} setShow={setShow} />
          <Item item={comprasItem} setTabla={setTabla} setShow={setShow} />
          <Item item={resumenGrafica} setTabla={setTabla} setShow={setShow} />
          <Item item={reportesItem} setTabla={setTabla} setShow={setShow} />
          <Item
            item={configuracionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <a
            href="/inicio"
            className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
          >
            <i className="fas fa-power-off me-2" />
            Salir
          </a>
        </Menu>
        <section className="col-xl-12 m-0 p-0 " style={{ height: "90dvh" }}>
          {vista[tabla]}
        </section>

        <Toasts
          show={toast.mostrar}
          titulo={toast.titulo}
          mensaje={toast.mensaje}
          onHideCancela={cerrarToast}
        />
        {/* <Footer /> */}
      </div>
    )
  );
}
export default MenuPrincipalCompra;
